export default "__VITE_ASSET__wn3pT$WC__"